export const windowStorage = window ? window.sessionStorage : undefined;
